import { useQuery } from '@tanstack/react-query';
import type { ApiResponse } from '../../@types/ApiResponse';
import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import { getJSON } from '../../fetch';
import useAuth from '../../hooks/useAuth';
import { getExternalView } from '../../utils/market';
import useMarketCode from '../branch/useMarketCode';

export interface AlertBanner {
  createdAt: string;
  heading: string;
  id: string;
  message: string;
  tone: 'error';
  updatedAt: '2024-01-23T13:43:39.013Z';
  path: string;
  expire?: string;
}

export const ALERT_BANNERS_QUERY = '/api/search/:marketCode/alert-banners';

const useAlertBanners = (): [AlertBanner[] | undefined, RequestStateQuery] => {
  const { getToken } = useAuth();
  const [marketCode] = useMarketCode();

  const visibility = getExternalView() === 'operations' ? 'External - Operations' : 'Dealer';

  const { data, isLoading, isSuccess, isError, isFetching } = useQuery<ApiResponse<AlertBanner[]>>({
    queryKey: [ALERT_BANNERS_QUERY, marketCode, visibility],
    queryFn: async () =>
      await getJSON<ApiResponse<AlertBanner[]>>(
        `/api/search/${marketCode}/alert-banners?visibility=${visibility}`,
        getToken()!,
      ),
    enabled: !!marketCode,
  });
  return [data?.response, { isLoading, isSuccess, isError, isFetching }];
};

export default useAlertBanners;
